import React from 'react';
import OrganizationManagement from '../components/OrganizationManagement';
import AlwaysShowWarning from '../components/AlwaysShowWarning';

const OrganizationManagementPage = () => {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Organization Warning Banner */}
      <AlwaysShowWarning />
      
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Organization Management</h1>
        <p className="text-gray-600">
          Create and manage your organizations, switch between teams, and control member access.
        </p>
      </div>
      
      <OrganizationManagement />
    </div>
  );
};

export default OrganizationManagementPage; 